export default __webpack_public_path__ + "static/media/campaign.6aca5088.jpg";